// extracted by mini-css-extract-plugin
export default {"receive":"Receive_receive__YFwRE","columns":"Receive_columns__YsB89","left":"Receive_left__bb0WG","right":"Receive_right__seoNf"};